var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "B_4L_main",
    d: "M38.7 21.2c0-9.8-8-17.8-17.8-17.8C11 3.4 3 11.4 3 21.2c0 8.9 6.5 16.3 15 17.6V26.4h-4.5v-5.2H18v-3.9c0-4.5 2.7-6.9 6.7-6.9 2 0 4 .3 4 .3v4.4h-2.2c-2.2 0-2.9 1.4-2.9 2.8v3.3h4.9l-.8 5.2h-4.2v12.5c8.7-1.4 15.2-8.8 15.2-17.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "B_4L_main",
    d: "M38.7 21.2c0-9.8-8-17.8-17.8-17.8C11 3.4 3 11.4 3 21.2c0 8.9 6.5 16.3 15 17.6V26.4h-4.5v-5.2H18v-3.9c0-4.5 2.7-6.9 6.7-6.9 2 0 4 .3 4 .3v4.4h-2.2c-2.2 0-2.9 1.4-2.9 2.8v3.3h4.9l-.8 5.2h-4.2v12.5c8.7-1.4 15.2-8.8 15.2-17.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b932475c918c0757c3924078ecc4f5cd.svg";
export { ForwardRef as ReactComponent };